<div class="pure-control-group">
  <label for="carrierName">{{ label }}</label>
  <div class="multi-select-wrapper">
    <input
      class="multi-select"
      (click)="onClick()"
      placeholder="Select options"
      [(ngModel)]="inputValue"
      readonly
    />
    <div class="select-option-wrapper" [ngClass]="{ hidden: !showDropdown }">
      <div class="dropdown-header" *ngIf="selectOptionList?.length > 0">
        <div
          class="select-option"
          *ngIf="selectOptionList?.length !== selectedOptions?.length"
          (click)="onSelectAll($event)"
        >
          Select All
        </div>
        <div
          class="select-option"
          *ngIf="selectOptionList?.length === selectedOptions?.length"
          (click)="onClearAll($event)"
        >
          Clear All
        </div>
        <i
          class="fa fa-times dropdown-close"
          aria-hidden="true"
          (click)="onClick()"
        ></i>
      </div>
      <div
        class="select-option"
        *ngFor="let option of selectOptionList"
        (click)="onOptionSelect(option, $event)"
        [ngClass]="{ 'option-selected': selectedOptions.includes(option) }"
      >
        {{ option }}
        <i
          *ngIf="selectedOptions.includes(option)"
          class="fa fa-check"
          aria-hidden="true"
        ></i>
      </div>
    </div>
  </div>
</div>
